// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JKgP63WM","wrapperWithWrapper":"yhIJdm5j","wrapperDefaultView":"ATYeADlx","defaultTitle":"d11ZYN8P","loading":"jqP05hl8","defaultContent":"taWYWvMo","area":"GstibDhI"};